export default function checkForWord(sentence:string, word:string):boolean {
    // Create a regular expression with word boundaries to match the whole word
    const regex = new RegExp('\\b' + word + '\\b', 'i'); // 'i' flag for case-insensitive matching
    return regex.test(sentence);
}